module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Banshee-S1.caa1224.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Banshee-S1.jpg
// module id = PQ0c
// module chunks = 0